import { useEffect, useState } from "react";

import SectionOne from "../sections/sectionOne";
import SectionImages from "../sections/sectionImages";
import SectionMultiple from "../sections/sectionMultiple";
import SectionWrapper from "../sections/wrapper";
import SectionSlider from "../sections/sectionSlider";
import WrappedSpinner from "../kit/WrappedSpinner";

import { fetchPage } from '../../sanity';

import { useParams } from "react-router";

export default function RootLayout({ settings }) {
    const [isLoading, setIsLoading] = useState(false);
    const [content, setContent] = useState(null);
    const { mainColor } = settings
    const params = useParams()



    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            try {
                const data = await fetchPage(params.slug);
                setContent(data);

            } catch (error) {
                console.error('Error fetching pages:', error);
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, [params.slug]);

    return (

        
            <main>
                <div>
                    {isLoading && <div className='h-screen w-screen bg-gray-200 flex justify-center items-center'>
                        <WrappedSpinner size='xl' text='Loading...' />
                    </div>}
                    {!isLoading && content?.sections?.map((c, i) => {
                        switch (c.type) {
                            case "sectionOne":
                                return <SectionWrapper key={"section" + i}><SectionOne data={c} mainColor={mainColor} /></SectionWrapper>
                            case "sectionImages":
                                return <SectionWrapper key={"section" + i}><SectionImages data={c} mainColor={mainColor} /></SectionWrapper>
                            case "sectionMultiple":
                                return <SectionWrapper key={"section" + i}><SectionMultiple data={c} mainColor={mainColor} /></SectionWrapper>
                            case "sectionSlider":
                                return <SectionWrapper key={"section" + i} full={true}><SectionSlider data={c} mainColor={mainColor} /></SectionWrapper>
                            default:
                                return ""
                        }
                    })}
                </div>
            </main>

    );
}










